import { Directive, Input, ElementRef, OnInit, Renderer2, OnDestroy } from '@angular/core';

/**
 * A directive for stopping the propagation of events on an element.
 * The `mcStopPropagation` directive stops the propagation of any number of events on an element.
 * `mcStopPropagation` can take an event name string or an array of event name strings as input.
 */
@Directive({
  selector: '[mcStopPropagation]'
})
export class StopPropagationDirective implements OnInit, OnDestroy {
  @Input('mcStopPropagation') events: string | string[];
  eventUnlisteners: Function[];

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    let events = this.events;

    if (typeof events === 'string') {
      events = [events];
    }

    if (Array.isArray(events)) {
      this.eventUnlisteners = events.map(event => this.renderer.listen(this.element.nativeElement, event, this.onEvent));
    }
  }

  ngOnDestroy() {
    if (this.eventUnlisteners) {
      this.eventUnlisteners.forEach(unlistener => unlistener());
      this.eventUnlisteners = null;
    }
  }

  onEvent(event) {
    event.stopPropagation();
  }
}
